import axios from 'axios';
import { getApiConfig } from './api';

// Create a dynamic axios instance
const createAxiosInstance = () => {
  const config = getApiConfig();
  const instance = axios.create({
    baseURL: config.API_URL,
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
    },
  });

  // Add request interceptor to include auth token
  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      const storeId = localStorage.getItem('selectedStoreId');
      if (storeId) {
        config.headers['x-store-id'] = storeId;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Add response interceptor for error handling
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Don't redirect if already on login page (login attempt failed)
        const isLoginPage = window.location.pathname === '/login' || window.location.pathname === '/';
        const isLoginRequest = error.config?.url?.includes('/auth/login');

        if (!isLoginPage && !isLoginRequest) {
          // Handle unauthorized access - only redirect if not on login page
          localStorage.removeItem('token');
          window.location.href = '/login';
        }
      }
      // Handle subscription expired
      if (
        error.response?.status === 403 &&
        error.response?.data?.error?.code === 'SUBSCRIPTION_EXPIRED'
      ) {
        window.dispatchEvent(new Event('subscription-expired'));
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

// Export a function that always returns a fresh axios instance
export const getAxiosInstance = createAxiosInstance;

// For backward compatibility, export a default instance
// But note: this will use the hostname from when the module was first loaded
const defaultInstance = createAxiosInstance();

export default defaultInstance;
